import { AuthContainer, ContinueWithEmail } from '@fhs/auth';

export default function ContinueWithEmailPage() {
  return (
    <AuthContainer>
      <ContinueWithEmail />
    </AuthContainer>
  );
}
